/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Still_Vole_PaceInputs */

const en_dry_still_vole_pace = /** @type {(inputs: Dry_Still_Vole_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update membership failed`)
};

const de_dry_still_vole_pace = /** @type {(inputs: Dry_Still_Vole_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Update membership failed" |
*
* @param {Dry_Still_Vole_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dry_still_vole_pace = /** @type {((inputs?: Dry_Still_Vole_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Still_Vole_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dry_still_vole_pace(inputs)
	return de_dry_still_vole_pace(inputs)
});